import { ComparisonPageTemplate } from '@/components/ComparisonPageTemplate'
import { getCompetitor } from '@/data/compare'

export default function WordPressComparePage() {
  return <ComparisonPageTemplate competitor={getCompetitor('wordpress')} />
}
